import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:type",
  content: "article"
}, null, -1)
const _hoisted_4 = ["content"]
const _hoisted_5 = ["content"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:image",
  content: "https://internationaltrashaward.org/international-trash-award.png"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:image:width",
  content: "630"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:image:height",
  content: "630"
}, null, -1)
const _hoisted_9 = ["content"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:site_name",
  content: "internationaltrashaward.org"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, _toDisplayString($setup.ogtitle), 1),
        _createElementVNode("meta", {
          name: "description",
          content: $setup.dynamicDescription
        }, null, 8, _hoisted_1),
        _createElementVNode("meta", {
          property: "og:locale",
          content: $setup.oglocale
        }, null, 8, _hoisted_2),
        _hoisted_3,
        _createElementVNode("meta", {
          property: "og:title",
          content: $setup.ogtitle
        }, null, 8, _hoisted_4),
        _createElementVNode("meta", {
          property: "og:description",
          content: $setup.dynamicDescription
        }, null, 8, _hoisted_5),
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("meta", {
          property: "og:url",
          content: $setup.ogurl
        }, null, 8, _hoisted_9),
        _hoisted_10
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ], 64))
}